import axios from 'axios'

export const backendUrl = process.env.VUE_APP_MURAIJA_BACKEND_URL
export const baseUrl = backendUrl + '/'

function call_api (path, params, user=null) {
  if (user) {
    return user.getIdToken().then( (token) => {
      return axios.post(baseUrl + path, params, { 'headers': 
        {'Authorization': `Bearer ${token}` }
      })
    })
  }
  else {
    return axios.post(baseUrl + path, params)
  }
}

export const api = {
  methods: {
    // Api calls requiring login (can be anonymous, though)
    updateSemanticGroups ({ lempos, pattern, core_indexes, groups, user}) {
      return call_api('update_semantic_groups',
      { lempos, pattern, core_indexes, groups }, user)
    },   
    rateCollocation: function ({lempos, pattern, rating, user}) {
      return call_api('rate_collocation', { lempos, pattern, rating }, user)
    },
    rateInstance: function ({ lempos, pattern, ref, rating, user }) {
      return call_api('rate_instance', { lempos, pattern, sentence_ref: ref, rating }, user)
    },

    // Api calls with optional login
    search ({query, minFreq=2, maxCount=10, user=null}) {
      return call_api('search', { query, min_freq: minFreq, max_count: maxCount }, user)
    },
    getCollocationSummary ({lempos, correct_ungrouped=true, unrated_by_freq=true, n=10, user=null}) {
      return call_api(
        'collocation_summary',
        { lempos, correct_ungrouped, unrated_by_freq, n },
        user
      )
    },
    getUnratedCollocations ({ lempos, pattern, core_indexes, n=10, sort_by='freq', user=null}) {
      return call_api('get_unrated_collocations', { lempos, pattern, core_indexes, n, sort_by}, user)
    },   
    getCollocation ({ lempos, pattern, user=null}) {
      return call_api('get_collocation', { lempos, pattern }, user)
    },
    getExample: function ({ ref, user=null }) {
      return call_api('get_example', { ref }, user)
    },
    getCollocations ({lempos, pattern=null, coreIndexes=null, rating=null, user=null}) {
      return call_api('collocations_as_json', { lempos, pattern, core_indexes: coreIndexes, rating, user })
    },
    
    // Api calls without user tracking
    getChanges (n = 20, olderThan = null) {
      return call_api('get_changes', { n, older_than: olderThan })
    },
    getRecentlyAddedGoodCols(n = 20) {
      return call_api('get_recently_added_good_cols', { n })
    },
    getStats () {
      return call_api('get_stats', {})
    },
    getUserStats (user) {
      return call_api('get_user_stats', {}, user)
    },

    // Helpers
    makeQualifiedPattern (pattern, coreIndexes) {
      return pattern + '@' + coreIndexes.join('@')
    },
    parseQualifiedPattern (s) {
      var parts = s.split('@')
      return [parts[0], parts.slice(1)]
    },
    lemposToLemma (s) {
      return s.split(' ').map(x => x.split('+')[0]).join(' ')
    },
    lemposToPos (s) {
      return s.split(' ').map(x => x.split('+')[1]).join(' ')
    }

  }
}
